export default "__VITE_ASSET__feb225a7__"